import React, { useEffect, useRef, useState } from "react";
import "./index.css";
// import playimg from "./play.svg";
// import pauseimg from "./pause.svg";

interface IProps {
  id?: number;
  url?: string;
  title_lesson: string;
  author?: string;
  previwUrl: string;
  onClickNextEx: () => void;
}

export function AudioLesson(props: IProps) {
  const audioElem = useRef<HTMLAudioElement>(null);
  const inFlightPlayRef = useRef<boolean>(false);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  useEffect(() => {
    const a = audioElem.current;
    if (!a) return;

    const onPlay = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);
    const onEnded = () => setIsPlaying(false);

    a.addEventListener("play", onPlay);
    a.addEventListener("pause", onPause);
    a.addEventListener("ended", onEnded);

    // Initial sync
    setIsPlaying(!a.paused);

    return () => {
      a.removeEventListener("play", onPlay);
      a.removeEventListener("pause", onPause);
      a.removeEventListener("ended", onEnded);
    };
  }, []);

  // If audio source changes (lesson navigation), stop playback and reset.
  useEffect(() => {
    const a = audioElem.current;
    if (!a) return;
    try {
      a.pause();
      a.currentTime = 0;
    } catch {
      // ignore
    }
    setIsPlaying(false);
  }, [props.url]);

  const togglePlayPause = async () => {
    const a = audioElem.current;
    if (!a) return;

    // Prevent race: if play() is pending, ignore toggles until it resolves.
    if (a.paused && inFlightPlayRef.current) return;

    // Use actual element state to avoid "play() then pause()" race.
    if (a.paused) {
      try {
        inFlightPlayRef.current = true;
        // play() returns a promise in modern browsers.
        const p = a.play();
        if (p && typeof (p as Promise<void>).then === "function") {
          await p;
        }
      } catch {
        // Autoplay might be blocked; keep UI consistent with the element.
        setIsPlaying(false);
      } finally {
        inFlightPlayRef.current = false;
      }
    } else {
      a.pause();
    }
  };
  return (
    <>
      <div className="audioConteinerFlexCenter">
        <div className="audioConteiner">
          <img className="trackImg" src={props.previwUrl} alt=""/>
          <h2>{props.title_lesson}</h2>
          <p>{props.author}</p>
          <audio className="lesson_audio_page" ref={audioElem} controls>
            <source src={"/" + props.url} type="audio/mp3" />
            <source src={"/" + props.url} type="audio/ogg" />
          </audio>
          {!isPlaying ? (
            <svg
              width="82"
              height="82"
              viewBox="0 0 82 82"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                void togglePlayPause();
              }}
              className="ppSvgBtn"
            >
              <path
                opacity="0.3"
                d="M82 40.3791C82 53.1761 59.8453 80.5094 37.4429 80.5094C15.0405 80.5094 0 58.3312 0 36.0306C0 13.73 22.5291 1.49121 44.9315 1.49121C67.3339 1.49121 82 27.5821 82 40.3791Z"
                fill="#5EA7DE"
              />
              <path
                opacity="0.3"
                d="M80.5091 43.071C80.5091 70.1742 47.9958 74.5457 25.7645 74.5457C3.53318 74.5457 0.745483 54.8731 0.745483 32.4545C0.745483 10.0359 25.8274 3.72754 48.0587 3.72754C70.29 3.72754 80.5091 24.336 80.5091 43.071Z"
                fill="#5EA7DE"
              />
              <circle cx="40.6273" cy="39.8817" r="33.1727" fill="#5EA7DE" />
              <path
                d="M34 31L48 40L34 49V31Z"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg
              width="82"
              height="82"
              viewBox="0 0 82 82"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                void togglePlayPause();
              }}
              className="ppSvgBtn"
            >
              <path
                opacity="0.3"
                d="M82 40.3791C82 53.1761 59.8453 80.5094 37.4429 80.5094C15.0405 80.5094 0 58.3312 0 36.0306C0 13.73 22.5291 1.49121 44.9315 1.49121C67.3339 1.49121 82 27.5821 82 40.3791Z"
                fill="#5EA7DE"
              />
              <path
                opacity="0.3"
                d="M80.5091 43.071C80.5091 70.1742 47.9958 74.5457 25.7645 74.5457C3.53318 74.5457 0.745483 54.8731 0.745483 32.4545C0.745483 10.0359 25.8274 3.72754 48.0587 3.72754C70.29 3.72754 80.5091 24.336 80.5091 43.071Z"
                fill="#5EA7DE"
              />
              <circle
                cx="40.6273"
                cy="39.8817"
                r="33.1727"
                fill="url(#paint0_linear_1653_2305)"
              />
              <path
                d="M39 32H35V48H39V32Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M47 32H43V48H47V32Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1653_2305"
                  x1="58.1351"
                  y1="11.0092"
                  x2="19.7408"
                  y2="66.9113"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#28BCD9" />
                  <stop offset="1" stop-color="#C791EE" />
                </linearGradient>
              </defs>
            </svg>
          )}
        </div>
      </div>
      <div
        className="lessonPageOnward-button"
        onClick={() => props.onClickNextEx()}
      >
        Далее
      </div>
    </>
  );
}
